import styled from '@emotion/styled';

const baseBox = ({ theme }) => ({
  display: 'flex',
  position: 'relative',
  backgroundColor: theme.palette.background.default,
  borderRadius: 6,
  height: 240,
  padding: '0px 12px',
});

export const Content = styled('div')(({ theme }) => ({
  display: 'block',
  border: `solid 1px ${theme.palette.border.main}`,
  borderRadius: 6,
  marginTop: 0,
  padding: 8,
}));

export const ContentError = styled('div')(({ theme }) => ({
  display: 'block',
  border: `solid 2px ${theme.palette.error.main}`,
  borderRadius: 6,
  marginTop: 0,
  padding: 8,
}));

export const FileContainer = styled('div')(({ theme }) => ({
  ...baseBox({ theme }),
  boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
}));

export const FileContainerDrag = styled('div')(({ theme }) => ({
  ...baseBox({ theme }),
  opacity: 0.5,
  border: 'dashed grey 2px',
}));

export const Image = styled('img')({
  width: '100%',
  height: '100%',
  borderRadius: 6,
  objectFit: 'contain',
});

export const UploadImage = styled('div')(({ theme }) => ({
  display: 'block',
  position: 'relative',
  backgroundColor: theme.palette.background.default,
  borderRadius: 6,
  cursor: 'pointer',
  height: 240,
  padding: '0px 12px',
  '&:hover': {
    boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
  },
}));

export const UploadImageDrag = styled(UploadImage)(({ theme }) => ({
  opacity: 0.5,
  border: 'dashed grey 2px',
}));

export const DeleteButton = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 8,
  right: 8,
  width: 32,
  height: 32,
  borderRadius: 32,
  backgroundColor: theme.palette.background.default,
}));

export const ReplaceButton = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 46,
  right: 8,
  width: 32,
  height: 32,
  borderRadius: 32,
  backgroundColor: theme.palette.background.default,
}));

export const UploadIcon = styled('div')({
  width: 48,
  height: 48,
  padding: 28,
  margin: '0 auto',
  marginBottom: 8,
  borderRadius: 48,
  backgroundColor: 'rgba(0, 0, 0, 0.08)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const AlignCenter = styled('div')({
  display: 'flex',
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
});

export const AlignContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
});
